export default "__VITE_ASSET__Bz18mRoS__"